export {
  OPERATORS,
  SCHEDULE_FACT_LABELS,
  getAvailableParameters,
  getParameterLabel,
  getDeviceParameterInfo,
  getPlantParameterInfo,
} from '@/features/rules-shared/schemas/condition-rules.utils.ts';

export const getMessageExamples = (ruleType: string) => {
  if (ruleType === 'schedule') {
    return [
      {
        title: 'No Active Setpoints for a Day',
        template: '{{plantName}} has no active setpoints scheduled for today ({{timestamp}}).',
      },
      {
        title: 'Charging Window Active',
        template:
          '{{plantName}} charging window is now active at {{setpointValue}} kW ({{timestamp}}).',
      },
      {
        title: 'Discharging Window Active',
        template:
          '{{plantName}} discharging window is now active at {{setpointValue}} kW ({{timestamp}}).',
      },
    ];
  }

  const deviceExamples = [
    {
      title: 'Simple Notification',
      template: '{{plantName}} requires attention',
    },
    {
      title: 'Battery Running Low',
      template:
        '{{plantName}} battery is at {{condition1Value}}% charge, below the safe level of {{condition1Threshold}}%.',
    },
    {
      title: 'String Connection Check',
      template:
        '{{plantName}} string configuration issue: {{condition1Threshold}} strings installed but only {{condition1Value}} strings connected.',
    },
    {
      title: 'Power Usage Too High',
      template:
        '{{plantName}} power use jumped to {{condition1Value}} kW at {{timestamp}}. Normal limit is {{condition1Threshold}} kW.',
    },
    {
      title: 'Device Temperature Alert',
      template:
        '{{deviceType}} (SN: {{deviceSN}}) temperature reached {{condition1Value}}°C, exceeding threshold of {{condition1Threshold}}°C.',
    },
    {
      title: 'Peak Shaving Opportunity',
      template:
        '{{plantName}} approaching peak demand period. Current load: {{condition1Value}} kW, peak threshold: {{condition1Threshold}} kW.',
    },
    {
      title: 'Multiple Conditions',
      template:
        '{{plantName}} alert: {{condition1Parameter}} is {{condition1Value}} and {{condition2Parameter}} is {{condition2Value}}.',
    },
  ];

  const plantExamples = [
    {
      title: 'Simple Notification',
      template: '{{plantName}} requires attention',
    },
    {
      title: 'Plant Offline Warning',
      template: '{{plantName}} has gone {{condition1Value}}.',
    },
    {
      title: 'Connection Restored',
      template: '{{plantName}} connection has been restored to {{condition1Value}} status.',
    },
  ];

  return ruleType === 'device' ? deviceExamples : plantExamples;
};
